package com.fireavert.units.shared.data_models.responses

import kotlinx.serialization.Serializable

@Serializable
data class GetUnitByIdResponse(
    val unitResponse: UnitResponse? = null
)
